export const isValidPhoneNumber = (phone: string) => {
  const phoneNumberPattern = /^\d{9}$/;
  return phoneNumberPattern.test(phone);
};
